import isNil from 'lodash/isNil'

export default class DebugGrid {
  constructor() {
    this.debugGrid = document.querySelector('.js-debug-grid')
    this.gridVisible = false
  }

  init() {
    if (!isNil(this.debugGrid)) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'g' && e.ctrlKey) {
          this.handleToggleGrid()
        }
      })
    }
  }

  handleToggleGrid = () => {
    if (this.gridVisible) {
      this.debugGrid.style.display = 'none'
      this.gridVisible = false
    } else {
      this.debugGrid.style.display = 'block'
      this.gridVisible = true
    }
  }
}
